import * as React from 'react';
import clsx from 'clsx';
import { getElementChildren, makeId } from '../../../utils';
import { Base, Text } from '../../Base';
import { SrOnly } from '../../Helper';
import Svg from '../../Svg';
import { useChoiceProvider } from './ChoiceGroupContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Choice-root_15z3w",
  "choice": "Choice-choice_2Zk1_",
  "label": "Choice-label_h1-vP",
  "wrapper": "Choice-wrapper_1GRBD",
  "icon": "Choice-icon_3UMHe",
  "radio": "Choice-radio_21a3h",
  "addon": "Choice-addon_2ap0W",
  "checked": "Choice-checked_-245u",
  "enabled": "Choice-enabled_1wGDp",
  "input": "Choice-input_27rUV",
  "disabled": "Choice-disabled_2aGEF"
};
export function Choice({
  type = 'radio',
  id,
  name,
  value,
  checked: checkedProp,
  defaultChecked,
  disabled,
  label,
  icon,
  iconTheme = 'anthracite',
  inputProps,
  className,
  children,
  onChange,
  ...extraProps
}) {
  const genId = React.useId();
  const inputId = makeId('choice', id || genId);
  const context = useChoiceProvider();
  const elements = getElementChildren(children);
  const labelSlot = elements.find(child => child.props?.slot === 'label');
  const additionalSlot = elements.find(child => child.props?.slot === 'additional');
  const addonSlot = elements.find(child => child.props?.slot === 'addon');
  const checked = (() => {
    if (typeof defaultChecked === 'boolean') {
      return undefined;
    }
    if (typeof checkedProp === 'boolean') {
      return checkedProp;
    }
    if (typeof context?.value === 'string') {
      return context.value === value;
    }
    return false;
  })();
  return /*#__PURE__*/_jsxs(Base, {
    className: clsx(styles.root, {
      [styles.enabled]: !disabled,
      [styles.disabled]: disabled,
      [styles.checked]: checked || defaultChecked
    }, className),
    ...extraProps,
    children: [/*#__PURE__*/_jsx(SrOnly, {
      children: /*#__PURE__*/_jsx("input", {
        ...inputProps,
        id: inputId,
        type: type,
        name: context?.name || name,
        value: value,
        defaultChecked: defaultChecked,
        checked: checked,
        disabled: disabled,
        className: styles.input,
        onChange: evt => {
          context?.onValueChange?.(value);
          onChange?.(evt);
        }
      })
    }), /*#__PURE__*/_jsxs(Base, {
      boxSizing: "border",
      flex: true,
      flexCol: true,
      borderRadius: "1x",
      className: styles.choice,
      children: [/*#__PURE__*/_jsxs(Base, {
        tagName: "label",
        htmlFor: inputId,
        flexGrow1: true,
        flex: true,
        gap: "spacing-3x",
        weight: "regular",
        className: styles.label,
        children: [/*#__PURE__*/_jsxs(Base, {
          flexGrow1: true,
          flex: true,
          gap: "spacing-3x",
          className: styles.wrapper,
          children: [icon ? /*#__PURE__*/_jsx(Svg, {
            name: icon,
            theme: iconTheme,
            className: styles.icon
          }) : null, /*#__PURE__*/_jsxs(Base, {
            flexGrow1: true,
            flex: true,
            flexCol: true,
            gap: "spacing-3x",
            children: [labelSlot || /*#__PURE__*/_jsx(Text, {
              weight: "semibold",
              children: label
            }), additionalSlot]
          })]
        }), /*#__PURE__*/_jsx(Base, {
          boxSizing: "border",
          flexShrink0: true,
          grid: true,
          placeItemsCenter: true,
          backgroundColor: "white",
          className: styles.radio
        })]
      }), addonSlot ? /*#__PURE__*/_jsx(Base, {
        className: styles.addon,
        children: addonSlot
      }) : null]
    })]
  });
}